<template>
	<div class="panel panel-primary">
		<div class="panel-heading">
			Workout Details
		</div>
		<div class="panel-body">
			<div class="form">
				<div class="row">
					<div class="col-xs-12 col-sm-12 col-md-6">
						<div class="form-group">
							<input v-model="workout.workout_name" :disabled="workout.locked" placeholder="Name" class="form-control"/>
						</div>
					</div>
					<div class="col-xs-12 col-sm-6 col-md-2">
						<div class="form-group">
							<div class="input-group">
								<input v-model="workout.distance" disabled placeholder="Distance" class="form-control text-right"/>
								<div class="input-group-addon">m</div>
							</div>
						</div>
					</div>
					<div class="col-xs-12 col-sm-6 col-md-2">
						<div class="form-group">
							<input v-model="formattedWorkoutDuration" disabled placeholder="Duration" class="form-control text-right"/>
						</div>
					</div>
					<div class="col-xs-12 col-sm-6 col-md-2">
						<div class="form-group">
							<select v-model="workout.course" :disabled="workout.locked" placeholder="Course" class="form-control chosen-select">
								<option value="SCM">SCM</option>
								<option value="LCM">LCM</option>
							</select>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-xs-9">
						<div class="form-group">
							<textarea v-model="workout.details" :disabled="workout.locked" v-on:keyup="processWorkout" v-on:keydown.tab.stop.prevent="handleTabKey" class="form-control" rows="50"></textarea>
						</div>
					</div>
					<div class="col-xs-3">
						<div class="row"><div class="col-xs-12">
						<table class="table table-striped">
							<thead>
							<tr>
								<th>Stroke</th>
								<th class="text-right">Distance</th>
							</tr>
							</thead>
							<tbody>
							<tr v-for="strokeData in workout.strokeMix">
								<td>{{strokeData.stroke}}</td>
								<td class="text-right">{{strokeData.distance}}m</td>
							</tr>
							</tbody>
							
						</table>
						</div>
						</div>
					</div>
<!--						<h3>JSON</h3>-->
<!--						<p>-->
<!--							{{ workout.json }}	-->
<!--						</p>-->
					</div>
						 
				</div>
				<div class="row">
					<div class="col-xs-12 text-right">
						<button v-on:click="cancelEdit" class="btn btn-danger">Cancel</button>
						<button v-on:click="saveWorkout" class="btn btn-success">Save</button>
						<div class="clearfix"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
</style>

<script>

export default {
	data: function () {
		return {
			workoutId: null,
			workout: {
				workout_name: null,
				distance: null,
				duration: null,
				course: 'SCM',
				details: null,
				favourite: false,
				locked: false,
				json: null,
				strokeMix: null
			},
		}
	},
	computed: {
		formattedWorkoutDuration() {
			if (this.workout.duration) {
				return this.formatSecondsAsTime(this.workout.duration)
			}
			return '0:00';
		}
	},
	mounted() {
		console.log('Training Set component mounted.');
	},
	methods: {
		setWorkoutData(workout_id, workout) {
			// Load the training set and populate the object
			this.debug('setWorkoutData');
			this.workoutId = workout_id;
			this.workout = {
				workout_name: workout.workout_name,
				distance: workout.distance,
				duration: workout.duration,
				course: workout.course,
				details: workout.details,
				favourite: workout.favourite,
				locked: workout.locked,
				strokeMix: null
			};
			this.workout.json = this.processWorkout();

		},
		loadEmptyWorkout() {
			this.debug('loadEmptyWorkout()');
			this.workout = {
				workout_name: null,
				distance: null,
				duration: null,
				course: 'SCM',
				details: null,
				favourite: false,
				locked: false,
				json: [],
				strokeMix: null

			};
			this.workoutId = null;
		},
		cancelEdit() {
			this.loadEmptyWorkout();
			this.$emit('workout-edit-cancelled');

		},
		saveWorkout() {
			this.debug('saveWorkout()');

			// Save the training set to the server - by default we create a new set but change the request if it's an update
			let requestUrl = '/api/v1/workout';
			let requestMethod = 'post';
			if (this.workoutId != null) {
				requestUrl = `/api/v1/workout/${this.workoutId}`;
				requestMethod='put';
			}
			axios({
				method: requestMethod,
				url: requestUrl,
				data: {
					workout: this.workout
				}
			}).then((response) => {
				// this.loadingInstance.close();
				this.debug(response.data);
				this.$emit('workout-updated');
			}).catch((error) => {
				// this.loadingInstance.close();
				this.$message({message: 'There was a problem saving the workout.', type: 'error'});
			});
		},
		handleTabKey(event) {
			// console.log(event.target);
			// console.log(event.target.value);
			// console.log(event.target.selectionStart);
			// console.log(event.target.selectionEnd);

			// get caret position/selection
			var val = event.target.value,
				start = event.target.selectionStart,
				end = event.target.selectionEnd;

			// set textarea value to: text before caret + tab + text after caret
			event.target.value = val.substring(0, start) + '\t' + val.substring(end);

			// put caret at right position again
			event.target.selectionStart = event.target.selectionEnd = start + 1;

			// prevent the focus lose
			return false;
		},
		formatSecondsAsTime(seconds) {

			var sec_num = parseInt(seconds, 10); // don't forget the second param
			var hours   = Math.floor(sec_num / 3600);
			var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
			var seconds = sec_num - (hours * 3600) - (minutes * 60);

			if (hours   < 10) {hours   = "0"+hours;}
			if (minutes < 10) {minutes = "0"+minutes;}
			if (seconds < 10) {seconds = "0"+seconds;}
			if (hours == 0) {
				return minutes+':'+seconds;
			}
			return hours+':'+minutes+':'+seconds;
		},
		debug(message) {
			console.log('WorkoutList: ' + message);
		},
		processWorkout() {
			if (this.workout.locked) {
				return;
			}
			var lines = this.workout.details.toLowerCase().split('\n');
			let distance = 0;
			let seconds = 0;
			var json = [];
			const lineRegex = new RegExp(/(?<reps>\d+){1}[^xX]*[xX]{1}[^xX\d]*(?<distance>\d+)?m?.*(?<stroke>freestyle|fr|fc|free|back|ba|bc|backstroke|fly|butterfly|breast|br|breaststroke|medley|im|dr|drill)?.*\@.*(?<interval>\d+[:.]+\d+)?(?<description>.*)?/);	
			lines.forEach ((line, lineIdx) => {
				if (line.length > 0) {
					// console.log(line);
					// const lineData = lineRegex.exec(line);
					// console.log(lineData);
					// let line_stroke = 'Freestyle';
					// let line_distance = 100;
					// let line_reps = 1;
					// if (lineData != null) {
					// 	if (lineData[3] != null) line_stroke = this.mapStroke(lineData[3]);
					// 	if (lineData[2] != null) line_distance = lineData[2];
					// 	if (lineData[1] != null) line_reps = lineData[1];
					//	
					// }
					// const line_total_distance = line_distance * line_reps;
					// json[lineIdx] = {
					// 	line: line,
					// 	distance: line_distance,
					// 	stroke: line_stroke,
					// 	reps: line_reps,
					// 	total_distance: line_total_distance,
					// 	data: lineData
					// };
					// distance += line_total_distance;
					let jsonData = this.processLine(line);
					jsonData.line = line;
					json[lineIdx] = jsonData;
					if ( ! isNaN(jsonData.total_distance)) {
						distance += jsonData.total_distance;
					}
					if ( ! isNaN(jsonData.total_seconds)) {
						seconds += jsonData.total_seconds;
					}
					
				}
				
			});
			this.workout.json = json;
			this.workout.distance = distance;
			this.workout.duration = seconds;
			this.workout.strokeMix = this.getStrokeMix();
			
		},
		processLine(line) {

			const lineRegex = new RegExp(/(?<reps>\d+){1}[^xX]*[xX]{1}[^xX\d]*(\d+)?m?\s*(freestyle|fr|fc|free|back|ba|bc|backstroke|fly|butterfly|fl|breast|br|breaststroke|medley|im|drill|dr|kick|pull)?\s*\@?\s*(?<interval>\d{0,2}[:.]+\d{1,2})?\s*(?<description>.*)?/);
			const setNameRegex = new RegExp(/^(?<set_name>[^0-9].*):$/);
			const repsLine = new RegExp( /^(?<reps>[\d+]{1,2})x$/ );
			
			if (setNameRegex.test(line)) {
				return this.transformSetNameLine(setNameRegex.exec(line));
			}
			if (repsLine.test(line)) {
				return this.transformRepsLine(repsLine.exec(line));
			}
			if (lineRegex.test(line)) {
				return this.transformLine(lineRegex.exec(line));
			}
			return {};
		},
		transformSetNameLine(lineData) {
			let set_name = '';
			if (lineData != null) {
				if (lineData[1] != null) set_name = lineData[1];
			}
			return {
				set_name: set_name,
				distance: 0,
				stroke: null,
				reps: 0,
				total_distance: 0,
				data: lineData
			};
			
		},
		transformRepsLine(lineData) {
			let line_reps = 1;
			if (lineData != null) {
				if (lineData[1] != null) line_reps = lineData[1];
			}
			return {
				distance: 0,
				stroke: null,
				reps: line_reps,
				total_distance: 0,
				data: lineData
			};
			
		},
		transformLine(lineData) {
			let line_stroke = 'Freestyle';
			let line_distance = 100;
			let line_reps = 1;
			let line_seconds = 60;
			if (lineData != null) {
				if (lineData[3] != null) line_stroke = this.mapStroke(lineData[3]);
				if (lineData[2] != null) line_distance = lineData[2];
				if (lineData[1] != null) line_reps = lineData[1];
				if (lineData[4] != null) line_seconds = this.convertIntervalToSeconds(lineData[4]);
			}
			const line_total_distance = line_distance * line_reps;
			const line_total_seconds = line_seconds * line_reps;
			return {
				distance: line_distance,
				stroke: line_stroke,
				seconds: line_seconds,
				reps: line_reps,
				total_distance: line_total_distance,
				total_seconds: line_total_seconds,
				data: lineData
			};
		},
		convertIntervalToSeconds(interval) {
			let seconds = 0;
			const segments = /(\d{1,2})?:(\d{1,2})/g.exec(interval);
			console.log(segments)
			seconds = parseInt(segments[2], 10);
			if (segments[1] != null) {
				seconds = seconds + (parseInt(segments[1],10) * 60);
			}
			return seconds;
		},
		getStrokeMix() {
			let data = this.workout.json.reduce(
				(accumulator, currentValue) => {
					if (currentValue.stroke) {
						console.log(accumulator);
						console.log(currentValue);
						if (accumulator[currentValue['stroke']]) {
							accumulator[currentValue['stroke']].distance += currentValue.total_distance
						} else {
							accumulator[currentValue['stroke']] = {
								stroke: currentValue.stroke,
								distance: currentValue.total_distance
							};
						}
					}
					return accumulator;

				},[]
			);
			console.log(data);
			let result = Object.keys(data).map(stroke => data[stroke]);
			console.log(result);
			return result;
		},
		mapStroke(stroke) {
			stroke = stroke.toLowerCase();
			switch (stroke) {
				case 'fr':
				case 'free':
				case 'fc':
				case 'freestyle':
					return 'Freestyle'
					break;
				case 'breasstroke':
				case 'br':
					return 'Breaststroke';
				case 'butterfly':
				case 'fl':
					return 'Butterfly';
				case 'backstroke':
				case 'ba':
				case 'bc':
					return 'Backstroke';
				case 'medley':
				case 'individual medley':
				case 'im':
					return 'Medley';
				case 'drill':
				case 'dr':
					return 'Drill';
				case 'pull':
					return 'Pull';
				case 'kick':
					return 'Kick';
				default:
					return stroke;
						
			}
		}
	}
}
</script>
